<div class="inactivity-content-container">
  <div class="inactivity-title">
    <div class="title">
      {{"¿Sigues ahí?" | translate}}
    </div>
  </div>
  <div class="inactivity-body">
    {{"Hemos detectado inactividad en tu sesión. Para continuar dentro de la banca, presiona el botón 'Continuar con mi sesión'" | translate}}
  </div>
  <div class="less-time">
    {{"Restan" | translate}} <span class="seconds">{{timeLeft}} {{"segundos" | translate}}</span>
  </div>
  <div class="loading-time">
    <div class="progress-bar" [style.width.%]="progressWidth"></div>
  </div>
  <div class="btns-container">
    <button class="btn btn-outline-info"
            (click)="stopTimer()">{{"Cerrar Sesion" | translate}}
    </button>
    <button
      class="btn btn-primary text-truncate overflow-hidden text-nowrap"
      (click)="continueSession()"
      >{{"Continuar con mi sesion" | translate}}</button>
  </div>
</div>
